import Vue from 'vue';
import {
  formatNumber,
  alignForNumber,
  autoResize,
  ProgressBarByFieldsRenderer,
  addGroupingInResponseData,
  LinkCellRenderer,
  getNodeChildDetails
} from '@/helpers/renderHelpers'
import { handlerResponse } from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    comments: [],
    documents: [],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      getNodeChildDetails: getNodeChildDetails,
      components: {
        'ReadinessProgressBar': ProgressBarByFieldsRenderer('shipped_in_tonnes', 'ordered_in_tonnes')
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value, null)
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    salesContractItems: [],
    invoiceListGroupingByOrders: []
  },
  getters: {
    salesContractItemsGrid(state) {
      return {...state.gridOptions};
    },
    invoiceListGroupingByOrdersGrid(state) {
      return {...state.gridOptions,
        ... {components: {
          'OrderLink': LinkCellRenderer('id', '/sales-orders/'),
          'InvoiceLink': LinkCellRenderer('invoice_id', '/sale/invoices/edit/', true)
        }}};
    },
    salesContractItems(state) {
      return state.salesContractItems;
    },
    invoiceListGroupingByOrders(state){
      return state.invoiceListGroupingByOrders;
    },
    comments(state) {
      return state.comments;
    },
    documents(state) {
      return state.documents;
    }
  },
  mutations: {
    setSalesContractItems(state, data) {
      state.salesContractItems = data;
    },
    setInvoiceListGroupingByOrders(state, data) {
      state.invoiceListGroupingByOrders = addGroupingInResponseData(data);
    },
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    }
  },
  actions: {
    loadSalesContractItems(store, payLoad) {
      Vue.http.get(`sales/sales_contracts/${payLoad.id}/sales_contract_items/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setSalesContractItems', data);
        });
    },
    loadCommentsList(store, payLoad) {
      Vue.http.get(`sales/sales_contracts/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payLoad) {
      Vue.http.get(`sales/sales_contracts/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    },
    loadInvoiceListGroupingByOrders(store, payLoad) {
      Vue.http.get(`sales/sales_contracts/${payLoad.id}/sales_orders/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setInvoiceListGroupingByOrders', data);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sales/contracts/salesContract.js